// extracted by mini-css-extract-plugin
module.exports = {"solutions":"Solutions_solutions__afi7y","solutions__wrapper":"Solutions_solutions__wrapper__9IxUX"};